import {put,takeLatest,call} from 'redux-saga/effects';
import * as userService from "../../../services/userService";
import {
    GET_USER,
    GET_USER_SUCCESS,
    GET_USER_ERROR
}
    from "../../actions/user";

function* getUserSaga(action) {
    try {
        const data=yield call(userService.GetUser,action.payload)
        yield put({
            type: GET_USER_SUCCESS,
            payload: data
        });

    } catch(error) {
        yield put({
            type: GET_USER_ERROR,error: error.data
        });
    }
}


export function* getUserSagaWatcher() {
    yield takeLatest(GET_USER,getUserSaga);
}